import { Routes } from '@angular/router';

import { accountSegments } from '@advania-cosoftware/wolf-router';

export const accountsRoutes: Routes = [
    {
        path: accountSegments.accounts,
        loadComponent: () => import('./pages/users/users-tab/users-tab.page').then((m) => m.UsersTabPage),
        children: [
            {
                path: `${accountSegments.entra}/:azureUserId`,
                loadComponent: () => import('./pages/users/entra-user/entra-user.page').then((m) => m.EntraUserPage),
            },
            {
                path: accountSegments.entra,
                loadComponent: () => import('./pages/users/entra-users/entra-users.page').then((m) => m.EntraUsersPage),
            },
            {
                path: `${accountSegments.activeDirectory}/:adUserId`,
                loadComponent: () =>
                    import('./pages/users/active-directory-user/active-directory-user.page').then(
                        (m) => m.ActiveDirectoryUserPage,
                    ),
            },
            {
                path: accountSegments.activeDirectory,
                loadComponent: () =>
                    import('./pages/users/active-directory-users/active-directory-users.page').then(
                        (m) => m.ActiveDirectoryUsersPage,
                    ),
            },
            {
                path: accountSegments.citrix,
                loadComponent: () =>
                    import('./pages/citrix/citrix-sessions/citrix-sessions.page').then((m) => m.CitrixSessionsPage),
            },
        ],
    },
    {
        path: accountSegments.groups,
        loadComponent: () => import('./pages/groups/groups-tab/groups-tab.page').then((m) => m.GroupsTabPage),
        children: [
            {
                path: accountSegments.entra,
                loadComponent: () =>
                    import('./pages/groups/entra-groups/entra-groups.page').then((m) => m.EntraGroupsPage),
            },
            {
                path: `${accountSegments.entra}/:azureGroupId`,
                loadComponent: () =>
                    import('./pages/groups/entra-group/entra-group.page').then((m) => m.EntraGroupPage),
            },
            {
                path: accountSegments.activeDirectory,
                loadComponent: () =>
                    import('./pages/groups/active-directory-groups/active-directory-groups.page').then(
                        (m) => m.ActiveDirectoryGroupsPage,
                    ),
            },
            {
                path: `${accountSegments.activeDirectory}/:adGroupId`,
                loadComponent: () =>
                    import('./pages/groups/active-directory-group/active-directory-group.page').then(
                        (m) => m.ActiveDirectoryGroupPage,
                    ),
            },
        ],
    },
];
